<template>
  <div class="terms-conditions">
    <cms-content type="Customer Services"/>
  </div>
</template>

<script>
  import CmsContent from '@/components/layout/CmsContent.vue'
  export default {
    components: {
      CmsContent
    }
  }
</script>
